import handlebars from '../../services/handlebars';
import { IFRAME, CONFIG, UNIT } from '../../utils/constants';

const productIframe = (getters) => {
  const iframe = getters[CONFIG.GET_IFRAME];
  const product = getters[UNIT.GET_SELECTED_PRODUCT];
  if (!product || !iframe) {
    return null;
  }
  return {
    ...iframe,
    code: product.code,
    productNameClean:
      product.institutionalPath ||
      product.title
        .normalize('NFD')
        .replace(/ /g, '-')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase(),
  };
};

export default {
  state: {
    enabled: true,
  },
  getters: {
    [IFRAME.GET_DATA]: (state, getters) => {
      const iframe = getters[CONFIG.GET_IFRAME];
      const product = getters[UNIT.GET_SELECTED_PRODUCT];
      if (!product || !iframe) {
        return null;
      }
      return {
        ...iframe,
        code: product.code,
        productNameClean:
          product.institutionalPath ||
          product.title
            .normalize('NFD')
            .replace(/ /g, '-')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase(),
      };
    },
    [IFRAME.GET_INTERACTION]: (state) => state.enabled,
    [IFRAME.GET_MY_ENTERPRISE_PAGE_URL]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          if (data.myEnterprise.enabled === false) return null;
          const mask = data.myEnterprise.pageMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_MY_ENTERPRISE_CARD_URL]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          if (data.myEnterprise.enabled === false) return null;
          const mask = data.myEnterprise.cardMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_CONSTRUCTION_PAGE_URL]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          if (data.construction.enabled === false) return null;
          const mask = data.construction.pageMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_CONSTRUCTION_CARD_URL]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          if (data.construction.enabled === false) return null;
          const mask = data.construction.cardMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_DECORATED_PAGE_URL]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          if (data.decorated.enabled === false) return null;
          const mask = data.decorated.pageMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_DECORATED_CARD_URL]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          if (data.decorated.enabled === false) return null;
          const mask = data.decorated.cardMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_ENGINEERING_NEWS_URL]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          const mask = data.news.engineeringMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_LOGO_MASK]: (_state, getters) => {
      try {
        const data = productIframe(getters);
        if (data) {
          const mask = data.logoMask;
          const template = handlebars.compile(mask);
          const url = template(data);
          return url;
        }
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    [IFRAME.GET_NEWS_TYPES]: (_state, getters) => {
      const data = productIframe(getters);
      if (data) {
        return data.news;
      }
      return [];
    },
    [IFRAME.GET_MY_ENTERPRISE_CARD]: (state) => state.enabled,
    [IFRAME.GET_CONSTRUCTION]: (state) => state.enabled,
  },
  mutations: {
    [IFRAME.SET_INTERACTION]: (state, payload) => {
      state.enabled = payload;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/iframes.js